const enum ContestInvitesStatusFilter {
  PENDING = 'PENDING',
}

export { ContestInvitesStatusFilter };
